import { Module }    from 'vuex';
import { RootState } from '@/store/store.types';
import actions       from '@/views/heat-map-configuration/store/heat-map-configuration.actions';
import mutations     from '@/views/heat-map-configuration/store/heat-map-configuration.mutations';
import state         from '@/views/heat-map-configuration/store/heat-map-configuration.state';
import getters       from '@/views/heat-map-configuration/store/heat-map-configuration.getters';
import { State }     from '@/views/heat-map-configuration/heat-map-configuration.types';

const store: Module<State, RootState> = {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
};

export default store;
